import "./WizardComponent.scss";
import {WizardStepComponentController} from "./step/WizardStepComponent";
import {IOnInit, IRootElementService, ITimeoutService} from "angular";
import {Observable} from "rxjs/Observable";
import {ReplaySubject} from "rxjs/ReplaySubject";
import {CurrentStep} from "./models/CurrentStep";

export const WizardComponent = "tfWizard";

export function tfWizard() {
    return {
        templateUrl: "app/js/components/wizard/WizardComponent.html",
        transclude: {
            footerSlot: "?tfWizardFooter"
        },
        bindings: {
            onStepChanged: "&",
            onComplete: "&",
            onCancel: "&",
            displayStepper: "<"
        },
        controllerAs: "ctrl",
        controller: WizardComponentController
    };
}

export class WizardComponentController implements IOnInit {

    public onStepChanged: (arg: { index: number }) => void;
    public onComplete: Function;
    public onCancel: Function;
    public displayStepper: boolean | null;

    public currentIndex = 0;
    public steps: Array<WizardStepComponentController> = [];
    private stepChanged$ = new ReplaySubject<CurrentStep>(1);

    private preventDoubleClick = false;

    /** @ngInject */
    public constructor(private $timeout: ITimeoutService, private $element: IRootElementService ) {
    }

    public $onInit(): void {
        this.draggableInit();
        this.stepChanged();
    }

    public draggableInit() {
        this.$element.ready(  () =>  {
            this.$element.parent().parent().parent().draggable({ handle: ".modal-header" });
            this.$element.addClass("draggable-modal");
        });
    }

    public registerStep(step: WizardStepComponentController) {
        this.steps.push(step);
        this.steps = this.steps.sort((a, b) => a.index - b.index);
        this.steps.forEach((s) => s.setVisibility(false));
        const currentStep = this.currentStep;
        currentStep.setVisibility(true);
    }

    public removeStep(step: WizardStepComponentController) {
        this.steps = this.steps.filter((s) => s.index !== step.index);
    }

    public next() {
        this.toStep(this.getTrueIndex(this.currentIndex + 1, true));
    }

    public previous() {
        this.toStep(this.getTrueIndex(this.currentIndex - 1, false));
    }

    public toStep(step: number) {
        if (this.isValidTransition(step)) {
            this.preventDoubleClick = true;
            const currentStep = this.currentStep;
            currentStep.setVisibility(false);
            this.currentIndex = step;
            const nextStep = this.steps[step];
            this.stepChanged();
            this.$timeout(() => {
                nextStep.setVisibility(true);
                // Delay on being able to move between steps
                this.$timeout(() => this.preventDoubleClick = false, 200);
            });
        }
    }

    private getTrueIndex(step: number, isNext: boolean) {
        if (isNext) {
            for (let num = step; num < this.steps.length; num++) {
                if (this.steps[num].enabled ?? true) {
                    return num;
                }
            }
        }

        for (let num = step; num >= 0; num--) {
            if (this.steps[num].enabled ?? true) {
                return num;
            }
        }

        return step;
    }

    private isValidTransition(step: number): boolean {
        const isInBounds = step >= 0 && step < this.steps.length;
        const isBackwards = step < this.currentIndex;
        return !this.preventDoubleClick && isInBounds && (isBackwards || this.currentStep.isValid());
    }

    public complete(result: any) {
        if (!this.preventDoubleClick && this.currentStep.isValid()) {
            this.onComplete({result});
        }
    }

    private get currentStep(): WizardStepComponentController {
        return this.steps[this.currentIndex];
    }

    private stepChanged() {
        const step = this.currentIndex;
        this.onStepChanged({index: step});
        const totalSteps = this.steps.length;
        const isFirst = step === 0;
        const isLast = step === (totalSteps - 1);
        const currentStep: CurrentStep = {
            step,
            first: isFirst,
            last: isLast
        };
        this.stepChanged$.next(currentStep);
    }

    public stepChanges(): Observable<CurrentStep> {
        return this.stepChanged$.asObservable();
    }

    public cancel() {
        this.onCancel();
    }
}
